import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsMerchantNetworkMerchantSchema = withDefaults({
  type: 'pcs-merchant-network-merchant',
  fields: [
    {
      kind: 'attribute',
      name: 'dataState',
    },
    {
      kind: 'attribute',
      name: 'dataStateLog',
    },
    {
      kind: 'attribute',
      name: 'deletedAt',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'pcsMerchant',
      type: 'pcs-merchant',
      options: {
        async: false,
        inverse: 'pcsMerchantNetworkMerchants',
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsNetworkMerchant',
      type: 'pcs-network-merchant',
      options: {
        async: false,
        inverse: 'pcsMerchantNetworkMerchants',
      },
    },
  ],
});

export default PcsMerchantNetworkMerchantSchema;
